import {
    AccessibilityChartColors,
    AccessibilityGradientCategoryColors,
    AccessibilityGradientNumericColors,
    AccessibilityNamedColors,
} from './theme-colors';

export const DARK_ACCESSIBILITY_THEME = {
    name: 'dark_accessibility',
    base: 'default',
    variables: {
        chartColors: [
            AccessibilityChartColors.color1, // 0 (figma color 11)
            AccessibilityChartColors.color2, // 1 (figma color 9)
            AccessibilityChartColors.color3, // 2 (figma color 2)
            AccessibilityChartColors.color4, // 3 (figma color 8)
            AccessibilityChartColors.color5, // 4 (figma color 1)
            AccessibilityChartColors.color11, // 5 (figma color 4) // waring color
            AccessibilityChartColors.color8, // 6 (figma color 3)
            AccessibilityChartColors.color12, // 7 (figma color 12)
            AccessibilityChartColors.color9, // 8 (figma color 7)
            '#424d69', // 9
            AccessibilityChartColors.color10, // 10 (figma color 13)
            AccessibilityChartColors.color7, // 11 (figma color 14)
            AccessibilityChartColors.color13, // 12 (figma color 15)
            AccessibilityChartColors.color6, // 13 (figma color 6)
            '#ffd5de', // 14
            '#b4e9db', // 15
            '#fef3d5', // 16
            '#eabeff', // 17
            '#cae5ff', // 18
            '#e9f4b1', // 19
            '#ffe6b3', // 20
            '#d6d3ff', // 21
            '#c1eef2', // 22
            '#e4e6eb', // 23
            '#424d69', // 24
            '#879ac3', // 25
            AccessibilityChartColors.color14, // 26 (figma color 5),
            AccessibilityChartColors.color15, // 27 (figma color 10),
        ],
        namedColors: {
            empty: AccessibilityNamedColors.grey,
            gradientCategory: {
                color1: AccessibilityGradientCategoryColors.color1,
                color2: AccessibilityGradientCategoryColors.color2,
                color3: AccessibilityGradientCategoryColors.color3,
                color4: AccessibilityGradientCategoryColors.color4,
                color5: AccessibilityGradientCategoryColors.color5,
            },
            gradientNumeric: {
                color1: AccessibilityGradientNumericColors.color1,
                color2: AccessibilityGradientNumericColors.color2,
                color3: AccessibilityGradientNumericColors.color3,
                color4: AccessibilityGradientNumericColors.color4,
                color5: AccessibilityGradientNumericColors.color5,
            },
        },

        alertStatuses: [
            '#C5CCDB', //0
            '#579FE6', //1
            '#2670FF', //2
            '#EDE98F', //3
            '#F8BD79', //4
            '#FAB0D3', //5
            '#ED7B68', //6
        ],

        demandFactors: [
            '#579FE6', //0
            '#C2ECFF', //1
            '#00B383', //2
            '#D5F2C4', //3
            '#FAD36D', //4
            '#FFF8BF', //5
            '#FFB660', //6
            '#FFCF96', //7
            '#FF708D', //8
            '#FFC9D5', //9
        ],

        batteryBankModel: {
            MARGINAL: '#733313',
            FAILURE: '#CA371A',
            IN_SERVICE: '#F19F64',
            REPLACEMENT: '#0039c1',
            seriesItems: [
                '#F19F64',
                '#0087FE',
                '#0F69BF',
                '#1B528E',
                '#23416B',
                '#D588B9',
                '#986A93',
                '#685275',
                '#54435D',
            ],
            axisLines: '#0D1C2E',
        },

        primary_default: '#fe9339',
        secondary_default: '#0c8ac7',
        warning_default: '#f9bf4c',
        warn_default: '#f0735b',

        fontColor: '#fff',
        fontHintColor: '#9fa9bd',
        backgroundChartColor: '#202840',
        backgroundBasicColor1: '#9fa9bd',

        tooltipBg: '#202840',

        axisNameText: '#c5ccdb',
        axisLine: '#6e707a',

        axisSliderBackground: '#202840', // color-basic-900
        axisSliderShadow: '#424d69', // color-basic-700
        axisSliderHandle: '#131729', // color-basic-1100

        tableFilterBg: '#131729',
        tableFilterColor: '#ffffff',

        new_data_color: '#fff',
        old_data_color: '#9fa9bd',
    },
};
